export default "__VITE_PUBLIC_ASSET__0136aeec__"